export class CompanyInfor{
    constructor (id?:number,cpnyID?: string,cpnyName?:string,address?: string,city?:string,state?: string,
        zip?:string,country?: string,phone?:string,fax?: string,director?:string,manager?: string,
        chiefAcct?:string,impExpCode?: string,bankAcct1?:string,bankAcct2?: string,bankAcct3?:string,bankAcct4?: string,
        bankAcct5?:string,bankName1?: string,bankName2?:string,bankName3?: string,bankName4?:string,bankName5?: string,
        s4Future01?: string,s4Future02?: string,s4Future03?: string,crtdUser?: string,crtdDate?: string,
        lUpdUser?: string,lUpdDate?: string,fiscalYear?: number,prepared?: string){
            this.Id = id;
            this.CpnyID = cpnyID;this.CpnyName = cpnyName;this.Address = address;this.City = city;
            this.State = state;this.Country = country;this.Zip = zip;this.Phone = phone;
            this.Fax = fax;this.Director = director;this.Manager = manager;this.ChiefAcct = chiefAcct;
            this.ImpExpCode = impExpCode;this.BankAcct1 = bankAcct1;this.BankAcct2 = bankAcct2;this.BankAcct3 = bankAcct3;
            this.BankAcct4 = bankAcct4;this.BankAcct5 = bankAcct5;this.BankName1 = bankName1;this.BankName2 = bankName2;
            this.BankName3 = bankName3;this.BankName4 = bankName4;this.BankName5 = bankName5;this.S4Future01 = s4Future01;
            this.S4Future02 = s4Future02;this.S4Future03 = s4Future03;this.CrtdUser = crtdUser;this.LUpdUser = lUpdUser;
            this.CrtdDate = crtdDate;this.LUpdDate = lUpdDate;this.FiscalYear = fiscalYear;this.Prepared = prepared;
    }
    Id: number;
    CpnyID: string;
    CpnyName: string;
    Address: string;
    City: string;
    State: string;
    Zip: string;
    Country: string;
    Phone: string;
    Fax: string;
    Director: string;
    Manager: string;
    ChiefAcct: string;
    ImpExpCode: string;
    BankAcct1: string;
    BankAcct2: string;
    BankAcct3: string;
    BankAcct4: string;
    BankAcct5: string;
    BankName1: string;
    BankName2: string;
    BankName3: string;
    BankName4: string;
    BankName5: string;
    S4Future01: string;
    S4Future02: string;
    S4Future03: string;
    CrtdUser: string;
    CrtdDate: string;
    LUpdUser: string;
    LUpdDate: string;
    FiscalYear: number;
    Prepared: string;
}